import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";

import { registerFont } from "./font_loader";

import { invoiceDocuStyles } from "../core/Helper";

import { InvoiceHeader } from "./invoice_header";

export function InvoiceBuilder(props) {
  // const [winState, setWinState] = props.winState;

  console.log(props.data);
  registerFont();
  return (
    <Document
      keywords={new Date().toLocaleDateString("en-EN")}
      onRender={(a) => console.log(a)}
    >
      <Page size="A4" style={invoiceDocuStyles.page}>
        <InvoiceHeader {...props} />
        <View style={invoiceDocuStyles.header}>
          <Text>TEST</Text>
        </View>
      </Page>
    </Document>
  );
}
